import qs from 'qs'
import axios from '../../index'

/**
 * @description 分销商采购车
 * @author txw
 * @date 2019-05-31
 * @export
 */
export function loadCartData () {
  return axios.post('/purchase/plan-cart-list')
}
/**
 * @description 勾选商品计算价格
 * @author txw
 * @date 2019-05-31
 * @export
 */
export function selectedGoods (params) {
  return axios.post('/purchase/cart-sum-price', qs.stringify(params))
}
/**
 * @description 加减商品计算商品价格
 * @author txw
 * @date 2019-05-31
 * @export
 */
export function updateGoodsNumPrice (params) {
  return axios.post('/purchase/upate-goods-quantity-price', qs.stringify(params))
}
/**
 * @description 提交采购单商品
 * @author txw
 * @date 2019-05-31
 * @export
 */
export function submitGoodsCart (params) {
  return axios.post('/purchase/produce-plan-order', qs.stringify(params))
}
/**
 * @description 删除采购单商品
 * @author txw
 * @date 2019-06-3
 * @export
 */
export function delGoods (params) {
  return axios.post('/purchase/delete-goods-to-cart', qs.stringify(params))
}
/**
 * @description 获取商品购物车数量
 * @author txw
 * @date 2019-06-3
 * @export
 */
export function getGoodsTotalNum () {
  return axios.post('/purchase/cart-quantity')
}
